/**
 * mcpbSlots — pure slot-array helpers for the MCPlayback grid.
 *
 * swapSlots — return a NEW slots array with positions i and j swapped (the drag-to-rearrange primitive,
 * mock swapSlots). Used by the View's drag-reorder so the timeline bands (keyed by slot index) follow
 * the cells. No-op (same reference) for same index / out-of-range / non-array so callers can dispatch
 * unconditionally without churn.
 */
export const swapSlots = (slots, i, j) => {
  if (!Array.isArray(slots)) return slots;
  if (i === j || i < 0 || j < 0 || i >= slots.length || j >= slots.length) return slots;
  const next = slots.slice();
  [next[i], next[j]] = [next[j], next[i]];
  return next;
};

// deriveConf — the camera COUNT sizes the grid (1→single, 2→2-up, 3-4→2×2). Used by the grid's in-place
// add/remove/load edits. (View-based playback sizes the INITIAL grid from the loaded view's span via
// util/layouts.tilesForCount, which goes up to 16; deriveConf's 4-cap is the legacy grid-edit path.)
export const deriveConf = (n) => {
  if (n >= 3) return 4;
  if (n === 2) return 2;
  return 1;
};

// removeAndResize — remove the cam at `index`, compact the survivors, and RE-DERIVE conf from the new
// count so the grid follows the cam count (removing down to 1 cam → single, not a 4-up with empty cells;
// David 2026-06-22). Returns { conf, slots } padded to conf. Mirrors the add/load sizing.
export const removeAndResize = (slots, index) => {
  const cur = Array.isArray(slots) ? slots : [];
  const filled = cur.filter((c, i) => c && i !== index);
  const conf = deriveConf(filled.length);
  return { conf, slots: Array.from({ length: conf }, (_, k) => filled[k] || null) };
};
